module.exports = __webpack_public_path__ + "static/media/sow-section-6-banner.145b6efb.svg";